import React from 'react'

import HikerIcon from '../icons/hiker.svg'
import ClockIcon from '../icons/clock.svg'
import PeackIcon from '../icons/peak.svg'

import PlaceHolder from '../components/PlaceHolder'
import Distance from '../components/Distance'
import TravelTime from '../components/TravelTime'
import Altitude from '../components/Altitude'

import { range } from '../utils'

import {
  useUrlParams,
  useRealtiveTrailConnection,
} from '../hooks'

import {
  useUserPosition
} from '../slices/userposition'


const Stats = (props) => {
  const { length, time, elevation } = props || {}
  return (
    <ul className="pwa__list__labels">
      { length!== null && (
        <li className="pwa__list__label">
          <PlaceHolder value={length} transparent={true}>
            <HikerIcon title={window.gettext('distance')} />
            <Distance value={length} />
          </PlaceHolder>
        </li>
      )}
      { time!== null && (
        <li className="pwa__list__label">
          <PlaceHolder value={time} transparent={true}>
            <ClockIcon title={window.gettext('travel time')} />
            <TravelTime value={time} />
          </PlaceHolder>
        </li>
      )}
      { elevation !== null && (
        <li className="pwa__list__label">
          <PlaceHolder value={elevation} transparent={true}>
            <PeackIcon title={window.gettext('elevation')} />
            <Altitude value={elevation} />
          </PlaceHolder>
        </li>
      )}
    </ul>
  )
}

const OnTrailStats = (props) => {
  const {route_id, trail_id:current_trail_id, step} = props
  const { elevation, length, deviation_length, time, deviation_time, trail_id } = step || {}
  const userPosition = useUserPosition()
  const { offsetLength, offsetTime } = useOffsetTrailStatsToRoute({
    route_id: route_id, 
    trail_id: trail_id, 
    current_trail_id: current_trail_id
  })
  const relativeLength = userPosition ? Math.abs(length - userPosition.distance) + deviation_length : length + deviation_length
  const relativeTime = userPosition ? Math.abs(time - userPosition.time) + deviation_time : time + deviation_time
  return <Stats length={offsetLength + relativeLength} time={offsetTime + relativeTime} elevation={elevation} />
}

const DeviationStats = (props) => {
  const {route_id, trail_id:current_trail_id, step} = props
  const { elevation, waypoint_quadhashs, trail_id } = step || {}
  const { offsetLength, offsetTime } = useOffsetStepStatsToRoute({
    route_id: route_id, 
    trail_id: trail_id, 
    current_trail_id: current_trail_id
  })
  const { distance, time } = useRealtiveTrailConnection({
    routeId: route_id,
    trailId: trail_id || current_trail_id,
    quadhash: waypoint_quadhashs[0]
  }
  ) || {}
  return <Stats length={offsetLength + distance} time={offsetTime + time} elevation={elevation} />
}

export const StepStats = React.memo((props) => {
  const {route_id, trail_id, step} = props
  if (!step) return <Stats />
  if (step.deviation_length > 500) return <DeviationStats step={step} route_id={route_id} trail_id={trail_id} />
  return <OnTrailStats step={step} route_id={route_id} trail_id={trail_id} />
})


export default Stats
